import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import currencyUtils from 'shared/src/currency'

import FieldSummary from '../widgets/FieldSummary'

const useStyles = makeStyles(theme => ({
  info: {
    fontSize: '0.8em',
    color: '#999',
  }
}))

const TotalSummary = ({
  formConfig,
  total,
  title = 'Total',
  rows = [],
  alternate,
}) => {

  const classes = useStyles()

  const baseArray = typeof(total) !== 'undefined' ? [{
    title,
    value: currencyUtils.title(formConfig.payment.currency, total),
    boldValue: true,
  }] : []
  
  const values = baseArray.concat(
    rows.map(row => {
      const total = currencyUtils.title(formConfig.payment.currency, row.total)
      const amount = row.value
      const price = currencyUtils.title(formConfig.payment.currency, row.price)
      return {
        plainTitle: true,
        title: row.short_title,
        value: (
          <div>
            {
              amount > 0 ? (
                <span className={ classes.info }>{ amount } @ { price } = </span>
              ) : null
            }
            <span className={ classes.total }>{ total }</span>
          </div>
        )
        
      }
    })
  )
  
  return (
    <FieldSummary
      data={ values }
      alternate={ alternate }
      padding={ 4 }
    />
  )
}

export default TotalSummary